import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DivButton from '../DivButton/DivButton.jsx'
import rootActions from 'actions/rootActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class ConfirmCSVDowloadDialog extends React.PureComponent {
  render() {
    const buttonContainerClassName = 'standard-modal-button-container'
    const { count, totalRows, pageSize, maxPageSize } = this.props
    return (
      <div className="standard-modal-content">
        <div className="message-content">
          <div style={{ marginBottom: '15px' }}>
            <br />
            {`Note: This table is displaying only part of the available data (showing ${count} of ${totalRows} rows).`}
            <br />
            <br />
            {pageSize < maxPageSize ? (
              <>
                <FontAwesomeIcon icon={['fas', 'hand-point-right']} /> You can
                continue or cancel and adjust the page size to include more
                records.
                <br />
                <br />
              </>
            ) : null}
            {this.props.hasPII ? (
              <>
                This table has accompanying PII (Personally Identifiable
                Information - such as patient name and date of birth).
                <br />
                <br />
                <FontAwesomeIcon icon={['fas', 'hand-point-right']} /> You can
                choose to download the table with or without the PII.
              </>
            ) : null}
          </div>
        </div>
        <div className={buttonContainerClassName}>
          <div />
          <DivButton
            className={'btn btn-danger'}
            aria-label={`modal cancel button`}
            onClick={this.props.closeSelf}
          >
            Cancel
          </DivButton>
          {this.props.hasPII ? (
            <>
              <div />
              <DivButton
                className={'btn btn-warning'}
                aria-label={`modal download button`}
                onClick={() => {
                  this.props.okHandler(true)
                  this.props.closeSelf()
                }}
                data-title={'Download CSV with PII'}
                data-toggle={'tooltip'}
                data-placement={'top'}
              >
                Download with PII
              </DivButton>
            </>
          ) : null}
          <div />
          <DivButton
            className={'btn btn-success'}
            aria-label={`modal download button`}
            onClick={() => {
              this.props.okHandler(false)
              this.props.closeSelf()
            }}
            data-title={'Download CSV'}
            data-toggle={'tooltip'}
            data-placement={'top'}
          >
            Download
          </DivButton>
          <div />
        </div>
      </div>
    )
  }
}

ConfirmCSVDowloadDialog.propTypes = {
  // callback function for okButton
  okHandler: PropTypes.func,
  // callback function for cancel button
  cancelHandler: PropTypes.func,
  count: PropTypes.number,
  totalRows: PropTypes.number,
  pageSize: PropTypes.number,
  maxPageSize: PropTypes.number
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(rootActions, dispatch)
}

export default connect(null, mapDispatchToProps)(ConfirmCSVDowloadDialog)
